import { React, useState, useRef } from "react";
//import "./SoleProprietorship.css";
import "./PrivateLimitedCompany.css";

import ContactPopup from "./ContactPopup";
const SoleProprietorship = () => {
     const [openPopup, setOpenPopup] = useState(false);
   const contactRef = useRef(null);
const scrollToContact = () => {
  contactRef.current?.scrollIntoView({ behavior: "smooth" });};

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Sole Proprietorship Registration</h1>

        <p className="subtitle">
          Start Your Business with Full Control
        </p>

        <p className="desc">
          Simple, Fast & Affordable Business Setup. We help individuals start their own business as a Sole Proprietor with minimal compliance and complete legal support. Perfect for freelancers, traders, and small business owners.
        </p>

        <div className="badges">
          <span>✔ Easy to Start</span>
          <span>✔ Lowest Cost Business Structure</span>
          <span>✔ Full Control of Business</span>
          <span>✔ Quick Registration Process</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact}>
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS */}
      <div className="section">
        <h2>What is a Sole Proprietorship?</h2>
        <p>
          A Sole Proprietorship is a business owned and managed by a single individual. It is the simplest form of business with no separate legal identity between the owner and the business.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of Sole Proprietorship</h2>
        <ul>
          <li>Easy to start and operate</li>
          <li>Minimal compliance requirements</li>
          <li>Low registration cost</li>
          <li>Complete control over business decisions</li>
          <li>Direct access to profits</li>
          <li>Suitable for small businesses and freelancers</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our Services Include</h2>
        <ul>
          <li>GST Registration (if applicable)</li>
          <li>Udyam Registration (MSME)</li>
          <li>Shop & Establishment License</li>
          <li>Current Bank Account Opening Support</li>
          <li>Business Registration Guidance</li>
          <li>Trade License Assistance (if required)</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Proprietor:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar Card</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof</li>
        </ul>

        <h3>For Business Address:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Registration Process</h2>
        <ul>
          <li>Consultation – Understand your business activity</li>
          <li>Document Collection – Submit required documents</li>
          <li>Registration Selection – GST / MSME / Shop License</li>
          <li>Application Filing – Submit to authorities</li>
          <li>Approval – Get registration certificates</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>MSME (Udyam) Registration</li>
              <li>Basic Guidance</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>GST Registration</li>
              <li>MSME Registration</li>
              <li>Bank Account Assistance</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>GST + MSME + Shop License</li>
              <li>Complete Business Setup Support</li>
              <li>Compliance Guidance</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Quick & Easy Setup</li>
          <li>Affordable Pricing</li>
          <li>Expert Support</li>
          <li>Transparent Process</li>
          <li>End-to-End Assistance</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is registration mandatory?</b> No, but licenses may be required.</p>
        <p><b>Can I open a business bank account?</b> Yes, with GST/MSME/Shop Act.</p>
        <p><b>Compliance level?</b> Very minimal compared to companies.</p>
        <p><b>Can I convert later?</b> Yes, you can upgrade to Pvt Ltd.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Start Your Business Today</h2>
        <p>Launch your sole proprietorship quickly and easily.</p>

         <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}
          >Contact Us Now</button>

          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"}
          >Free Consultation</button>
        </div>

      </div>

    </div>
  );
};

export default SoleProprietorship;